import { ReactComponent as ArrowLeft } from '../../assets/icons/arrowLeft.svg';
import { ReactComponent as Building } from '../../assets/icons/building.svg';
import { ReactComponent as Checkmark } from '../../assets/icons/checkmark.svg';
import { ReactComponent as Lock } from '../../assets/icons/lock.svg';
import { ReactComponent as Send } from '../../assets/icons/send.svg';
import { ReactComponent as Unlock } from '../../assets/icons/unlock.svg';

interface IconProps {
  color: string;
}

const Icon = {
  ArrowLeft: (props: IconProps) => <ArrowLeft fill={props.color} />,
  Building: (props: IconProps) => <Building fill={props.color} />,
  Checkmark: (props: IconProps) => <Checkmark stroke={props.color} />,
  Lock: (props: IconProps) => <Lock stroke={props.color} />,
  Send: (props: IconProps) => <Send stroke={props.color} />,
  Unlock: (props: IconProps) => <Unlock stroke={props.color} />,
};

export default Icon;
